import ButtonUnderText from 'components/atoms/Button/Button.underText';
import { autoCompleteState } from 'modules/actions/autoComplete';
import { changeFontSize } from 'modules/actions/fontSize';
import useRequestDM from 'modules/hooks/useRequestDM';
import { disableAllMenu } from 'modules/actions/statusMenu';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
/**
 * 하단의 메뉴 컴포넌트
 * @returns {object} ChatMenu
 */
const ChatMenu = ({ styleDef }) => {
  const currentFontSize = useSelector(state => state.fontSize);

  const dispatch = useDispatch();

  const execOnSendMsg = text => {
    dispatch(useRequestDM(text, 'query'));
    dispatch(disableAllMenu());
  };
  const onLink = url => {
    window.open(url,"_blank", false);
  };

  const iconStyle = {
    backgroundColor: '#0056E0',
    borderRadius: '50%',
    color: '#fff',
    width: '40px',
    height: '40px',
    fontSize: '23px',
  };

  return (
    <div className="_quick_div" style={styleDef}>
      <div className="_quick_menu">
        <ButtonUnderText
          label="처음으로"
          value="처음으로"
          labelIcon="ri-restart-line"
          viewStatus=""
          styleDef={iconStyle}
          onClickEvt={() => window.location.reload()}
          error={null}
        />
        <ButtonUnderText
          label="민원신청"
          value="민원신청"
          labelIcon="ri-draft-line"
          viewStatus=""
          styleDef={iconStyle}
          onClickEvt={() => execOnSendMsg('민원신청')}
          error={null}
        />
        <ButtonUnderText
          label="홈페이지"
          value="홈페이지"
          labelIcon="ri-wechat-line"
          viewStatus=""
          styleDef={iconStyle}
          onClickEvt={() => onLink("https://www.seo.incheon.kr/open_content/main")}
          error={null}
        />
        <ButtonUnderText
          label="분야별안내"
          value="분야별안내"
          labelIcon="ri-stack-line"
          viewStatus=""
          styleDef={iconStyle}
          // onClickEvt={() => dispatch(changeFontSize(currentFontSize === 15 ? 20 : 15))}
          onClickEvt={() => execOnSendMsg("분야별 안내")}
          error={null}
        />
      </div>
    </div>
  );
};
ChatMenu.propTypes = {
  styleDef: PropTypes.object,
};
ChatMenu.defaultProps = {
  styleDef: {},
};
export default ChatMenu;
